import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePublicLanguage } from '../contexts/PublicLanguageContext';
import { pathInLanguage, PublicLang } from '../i18n/publicPaths';
import LangFlag from './LangFlag';
import './LanguageSwitcher.css';

const LANGUAGES: { code: PublicLang; label: string; aria: string }[] = [
  { code: 'en', label: 'EN', aria: 'Switch to English' },
  { code: 'es', label: 'ES', aria: 'Cambiar a Español' },
  { code: 'pt', label: 'PT', aria: 'Mudar para Português' },
];

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = usePublicLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const choose = (lang: PublicLang) => {
    if (lang === language) return;
    setLanguage(lang);
    // Move to the URL that language lives at, so the choice survives a reload
    // and the address bar agrees with what search engines indexed. Pages with
    // no translation (terms, coming-soon) just re-render where they are.
    const target = pathInLanguage(location.pathname, lang);
    if (target && target !== location.pathname) {
      navigate(target);
    }
  };

  return (
    <div className="language-switcher">
      {LANGUAGES.map((lang, i) => (
        <React.Fragment key={lang.code}>
          {i > 0 && <span className="lang-divider">|</span>}
          <button
            className={`lang-button ${language === lang.code ? 'active' : ''}`}
            onClick={() => choose(lang.code)}
            aria-label={lang.aria}
          >
            <LangFlag lang={lang.code} size={12} />
            {lang.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
